<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">link_off</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">{{ titulo }}</h2>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <p class="vinculo-mensagem">{{ mensagem }}</p>

  @if (temCandidatos) {
  <mat-radio-group class="opcoes" [(ngModel)]="modo">
    <div class="opcao" [class.opcao--selecionada]="modo === 'reatribuir'" (click)="modo = 'reatribuir'">
      <mat-radio-button value="reatribuir">Reatribuir para outro tipo tributário</mat-radio-button>
      <p class="opcao-descricao">Os cadastros vinculados passam a usar o tipo escolhido.</p>
      @if (modo === 'reatribuir') {
      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic" (click)="$event.stopPropagation()">
        <mat-label>Tipo tributário de destino</mat-label>
        <mat-select [(ngModel)]="idDestino" [ngModelOptions]="{ standalone: true }">
          @for (c of data.candidatos; track c.idTipoTributario) {
          <mat-option [value]="c.idTipoTributario">{{ c.codigo }} — {{ c.descricao }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      }
    </div>

    <div class="opcao" [class.opcao--selecionada]="modo === 'desvincular'" (click)="modo = 'desvincular'">
      <mat-radio-button value="desvincular">Deixar os cadastros sem tipo tributário</mat-radio-button>
      <p class="opcao-descricao">O vínculo é removido e os cadastros ficam sem tipo tributário.</p>
    </div>
  </mat-radio-group>
  } @else {
  <app-alert-card type="warning">{{ mensagemSemCandidatos }}</app-alert-card>
  }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <button mat-flat-button class="btn-primary" (click)="confirmar()" [disabled]="isConfirmDisabled">
    Confirmar exclusão
  </button>
</mat-dialog-actions>
